import api from 'app/api';
import store from 'app/store';
import mixpanel from 'mixpanel-browser';

export const getEventById = async (id, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'SELL_TICKET:EVENT_DATA:SET', data });

    if (callback) callback(data);
  };

  const url = `/events/${id}`;

  await api.get(url, {
    id: 'get-event-by-id',
    success: {
      callback: successCallback,
    },
    params: {
      isSecondary: true,
    },
  });
};

export const verifyTicket = async (payload, successCb, failureCb) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'SELL_TICKET:VERIFICATION_DATA:SET', data });

    if (data?.verificationStatus === 'success') successCb(data);
    else failureCb(data);
  };

  const failureCallback = (err) => {
    if (failureCb) failureCb(err?.description);
  };

  const url = `/tickets/verify`;

  await api.post(url, payload, {
    id: 'verify-tickets',
    success: {
      callback: successCallback,
    },
    failure: {
      callback: failureCallback,
    },
  });
};

export const bookTicket = async (payload, successCb, failureCb) => {
  const successCallback = ({ data }) => {
    mixpanel.track("Listing_Confirmed", {
      "event_id": data?.event,
      "category_name": data?.ticketCategoryName,
      "ticket_price": data?.ticketPrice,
      "ticket_quantity": data?.tickets,
      "user_id": data?.user,
      "listing_status": "Active",
      "page_url": window.location.href,
    });
    if (successCb) successCb(data);
  };

  const failureCallback = (err) => {
    if (failureCb) failureCb(err);
  };

  const url = `/tickets/book`;

  await api.post(url, payload, {
    id: 'book-ticket',
    success: {
      callback: successCallback,
    },
    failure: {
      callback: failureCallback,
    },
  });
};

export const updateUserContact = async (payload, successCb, failureCb) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'APP:USER_DATA:SET', data });
    if (successCb) successCb(data);
  };

  const failureCallback = (err) => {
    if (failureCb) failureCb(err);
  };

  const url = `/user/contactDetails`;

  await api.put(url, payload, {
    id: 'update-contact',
    success: {
      callback: successCallback,
    },
    failure: {
      callback: failureCallback,
    },
  });
};

export const notifyTeam = async (payload, successCb, failureCb) => {
  const url = `/user/notifyTeam`;

  await api.post(url, payload, {
    id: 'update-contact',
    success: {
      callback: successCb,
    },
    failure: {
      callback: failureCb,
    },
  });
};
